import {createFeatureSelector, createSelector} from '@ngrx/store';

import {RegionInfo} from '../models/region.model';
import {DayOfWeek, ServiceRegion} from '../../../common/constants';
import {S3BASEURL} from '../shared/constants';

const _selectRegionRootState = createFeatureSelector<RegionInfo>('region');

export const selectProjectRegionInfo = createSelector(
  _selectRegionRootState,
  (state: RegionInfo) => state
);
export const selectProjectRegionTimeFormats = createSelector(
  selectProjectRegionInfo,
  (state: RegionInfo) => state.dateFormats
);

export const selectRegion = createSelector(
  _selectRegionRootState,
  ({region}): ServiceRegion => region
);

export const selectProjectRegionFlag = createSelector(
  selectRegion,
  (serviceRegion: ServiceRegion): string => `${S3BASEURL}${serviceRegion}.png`
);

export const selectRegionWeekStartsOn = createSelector(
  _selectRegionRootState,
  ({weekStartsOn}): DayOfWeek => weekStartsOn
);
